import { AxiosError } from "axios";

import { showsSessionExpiredModalAtom, store } from "@/utils/atoms";
import { isBillingActionBlockedError } from "@/utils/billingActionBlockedError";

export const isSessionExpiredModalShown = (): boolean =>
  store.get(showsSessionExpiredModalAtom) === true;

export const isSessionExpiryError = (err: unknown): boolean => {
  if (err instanceof Error && err.message === "Session expired") {
    return true;
  }

  if (!(err instanceof AxiosError)) {
    return false;
  }

  const status = err.response?.status;
  if (status === 401 || (status === 403 && !isBillingActionBlockedError(err))) {
    return true;
  }

  const errorCode = err.response?.data?.error;
  if (errorCode === "invalid_token") {
    return true;
  }

  const errorDescription = err.response?.data?.error_description;
  if (
    typeof errorDescription === "string" &&
    errorDescription.includes("Invalid refresh token")
  ) {
    return true;
  }

  if (status === 400 && err.message.includes("invalid_token")) {
    return true;
  }

  return false;
};

/** Skip generic error toasts when the session-expired modal is (or should be) shown. */
export const shouldSuppressErrorNotification = (err?: unknown): boolean =>
  isSessionExpiredModalShown() ||
  (err !== undefined && isSessionExpiryError(err));
